const routes = [
  // 营销活动
  {
    // 优惠劵
    path: "/wechat/activity/coupon",
    name: "wechatActivityCoupon",
    meta: {
      title: "优惠劵",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue")
  },
  {
    // 支付有礼
    path: "/wechat/activity/giftPay",
    name: "wechatActivityGiftPay",
    meta: {
      title: "支付有礼",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue")
  },
  {
    // 新客有礼
    path: "/wechat/activity/giftnew",
    name: "wechatActivityGiftnew",
    meta: {
      title: "新客有礼",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue")
  },
  {
    // 弹窗广告
    path: "/wechat/activity/advert",
    name: "wechatActivityAdvert",
    meta: {
      title: "弹窗广告",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue")
  },
  {
    // 拼团
    path: "/wechat/activity/group",
    name: "wechatActivityGroup",
    meta: {
      title: "拼团",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue")
  },
  {
    // 秒杀
    path: "/wechat/activity/kill",
    name: "wechatActivityKill",
    meta: {
      title: "秒杀",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue")
  },
  {
    // 砍价
    path: "/wechat/activity/bargain",
    name: "wechatActivityBargain",
    meta: {
      title: "砍价",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue")
  },
  {
    // 分销
    path: "/wechat/activity/distribution",
    name: "wechatActivityDistribution",
    meta: {
      title: "分销",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue")
  },
  {
    // 直播带货
    path: "/wechat/activity/live",
    name: "wechatActivityLive",
    meta: {
      title: "直播带货",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue")
  },

  // 商城数据概况
  {
    // 数据概况
    path: "/wechat/data/index",
    meta: {
      title: "商城数据",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatDataIndex"
  },
  {
    // 收入提现(兼容老版菜单)
    path: "/wechat/data/income",
    meta: {
      title: "收入提现",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatDataIncome"
  },
  {
    // 收入提现(兼容老版菜单)
    path: "/wechat/data/bill",
    meta: {
      title: "更多功能",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatDataBill"
  },
  {
    // 收入提现
    path: "/wechat/bill/income",
    meta: {
      title: "提现管理",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatDataBill"
  },
  {
    // 收入提现
    path: "/wechat/bill/index",
    meta: {
      title: "提现管理",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatDataBill"
  },
  {
    // 商城设置
    path: "/wechat/other/index",
    meta: {
      title: "商城设置",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatDataSetting"
  },
  {
    // 短信服务
    path: "/wechat/data/smsService",
    meta: {
      title: "短信服务",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatDataSmsService"
  },
  {
    // 操作日志
    path: "/wechat/data/log",
    meta: {
      title: "操作日志",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatDataLog"
  },

  // 商品管理
  {
    // 自营商品
    path: "/wechat/goods/index",
    meta: {
      title: "商品管理",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatGoodsIndex"
  },
  {
    // 平台分销商品
    path: "/wechat/goods/platformSell",
    meta: {
      title: "平台分销商品",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatGoodsPlatformSell"
  },
  {
    // 进购库存列表-市场采购
    path: "/wechat/goods/stockList",
    meta: {
      title: "市场采购",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatGoodsStockList"
  },
  {
    // 商品分类
    path: "/wechat/goods/classification",
    meta: {
      title: "商品分类",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatGoodsClassification"
  },
  {
    // 商品规格
    path: "/wechat/goods/specs",
    meta: {
      title: "商品规格",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatGoodsSpecs"
  },
  {
    // 商品属性
    path: "/wechat/goods/attribute",
    meta: {
      title: "商品属性",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatGoodsAttribute"
  },

  // 海报管理
  {
    // 海报管理
    path: "/wechat/poster/index",
    meta: {
      title: "海报管理",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatPosterIndex"
  },

  // 小程序预览
  {
    // 小程序
    path: "/wechat/video",
    meta: {
      title: "家长通小程序",
      volcengine: true
    },
    component: () => import("../pages/iframe/wechat.vue"),
    name: "wechatVideo"
  },
  // 页面定制
  {
    path: "/wechatPageCustom",
    meta: {
      title: "页面定制",
      volcengine: true
    },
    component: () => import("../pages/iframe/shareDownloadPage.vue"),
    name: "wechatPageCustom"
  },
  {
    // 小程序
    path: "/wechat/preview/minp",
    meta: {
      title: "小程序预览",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatPreviewMinp"
  },

  // app收费套餐
  {
    // app收费套餐
    path: "/wechat/app/cost",
    meta: {
      title: "app收费套餐",
      volcengine: true
    },
    component: () => import("../pages/wechatAppCost/index.vue"),
    name: "wechatAppCost"
  },

  // 视频管理
  {
    // 视频作品
    path: "/wechat/video/index",
    meta: {
      title: "首页短视频",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatVideoIndex"
  },
  {
    // 视频分类
    path: "/wechat/video/classify",
    meta: {
      title: "视频分类",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatVideoClassify"
  },

  // 订单中心
  {
    // 订单列表
    path: "/wechat/order/list",
    meta: {
      title: "订单列表",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatOrderList"
  },
  {
    // 订单售后
    path: "/wechat/order/aftersales",
    meta: {
      title: "订单售后",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatOrderAftersales"
  },
  {
    // 电子卡券
    path: "/wechat/order/card",
    meta: {
      title: "电子卡券",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatOrderCard"
  },
  {
    // 核销管理
    path: "/wechat/order/writeoff",
    meta: {
      title: "核销管理",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatOrderWriteoff"
  },
  {
    // 收入提现
    path: "/wechat/order/income",
    meta: {
      title: "收入提现",
      volcengine: true
    },
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatOrderIncome"
  },
  {
    path: "/wechat/activity_benefit/benefit/index",
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatActivityBenefit"
  },
  {
    path: "/wechat/admin/index/home",
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatRealTime"
  },
  {
    path: "/wechat/statistics/index/get_user",
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatGetUser"
  },
  {
    path: "/wechat/statistics/index/get_user_rank",
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatGetUserRank"
  },
  {
    path: "/wechat/statistics/index/video_rank",
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatVideoRank"
  },
  {
    path: "/wechat/statistics/index/visit",
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatVisit"
  },
  {
    path: "/wechat/order/index/index",
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatOrderIndex"
  },
  {
    path: "/wechat/knowledge/content/index",
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatKnowledge"
  },
  {
    path: "/wechat/index/select_class_id",
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatArticle"
  },
  {
    path: "/wechat/form/index/index",
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatForm"
  },
  {
    path: "/wechat/admin/index/webShop",
    component: () => import("../pages/iframe/index.vue"),
    name: "purchasingMall"
  },
  {
    path: "/wechat/admin/index/sms",
    component: () => import("../pages/iframe/index.vue"),
    name: "sms"
  },
  {
    path: "/wechat/miniapp/template/index",
    component: () => import("../pages/iframe/index.vue"),
    name: "miniapp"
  },
  // 营销活动
  {
    path: "/wechat/activity_coupon/coupon/coupon_list",
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatActivityCoupon"
  },
  // 招生宝
  {
    path: "/wechat/recruit/templateLib",
    component: () => import("../pages/iframe/index.vue"),
    name: "wechatRecruitTemplateLib"
  },
];
export default routes;
